import PubSub from "../../utils/PubSub";
import updateCartQuantity from "../../pages/cart/updateCartQuantity";
import removeCartItem from "../../pages/cart/removeCartItem";

export default function setupOffcanvasCartUI() {
  const cartToggle = document.querySelector("#cart-toggle");
  const cartOffcanvas = document.querySelector(".cart-offcanvas");
  const closeCart = document.querySelector(".close-cart");
  const cartOffcanvasContent = document.querySelector(
    ".cart-offcanvas-content"
  );
  const overlay = document.querySelector(".overlay");

  // Offcanvas control functions
  function openCartOffcanvas() {
    cartOffcanvas.classList.remove("hide");
    cartOffcanvas.classList.add("show");
    overlay.classList.remove("hide");
    overlay.classList.add("show");
    document.body.style.overflow = "hidden";
  }

  function closeCartOffcanvas() {
    cartOffcanvas.classList.remove("show");
    cartOffcanvas.classList.add("hide");
    overlay.classList.remove("show");
    overlay.classList.add("hide");
    document.body.style.overflow = "";
  }

  // Event listeners for Offcanvas controls
  if (cartToggle) cartToggle.addEventListener("click", openCartOffcanvas);
  if (closeCart) closeCart.addEventListener("click", closeCartOffcanvas);
  if (overlay) overlay.addEventListener("click", closeCartOffcanvas);

  // Cart item interactions
  if (cartOffcanvasContent) {
    cartOffcanvasContent.addEventListener("click", (e) => {
      const cartItem = e.target.closest(".cart-offcanvas-item");
      if (!cartItem) return;

      handleCartItemInteraction(e, cartItem);
    });
  }

  // Subscribe to cart update events
  setupCartEventSubscriptions();
}

function handleCartItemInteraction(e, cartItem) {
  const key = cartItem.dataset.key;

  if (e.target.classList.contains("quantity-btn")) {
    handleQuantityChange(e, cartItem);
  }

  if (e.target.classList.contains("remove-item")) {
    removeCartItem(key);
  }
}

function handleQuantityChange(e, cartItem) {
  const input = cartItem.querySelector("input");
  const currentVal = parseInt(input.value);
  const maxStock = parseInt(input.getAttribute("data-stock"), 10) || 9999;

  let newValue = currentVal;

  if (e.target.classList.contains("minus") && currentVal > 1) {
    newValue = currentVal - 1;
  } else if (e.target.classList.contains("plus") && currentVal < maxStock) {
    newValue = currentVal + 1;
  } else {
    return;
  }

  updateCartQuantity(cartItem.dataset.key, newValue);
}

function setupCartEventSubscriptions() {
  // Handle quantity updates
  PubSub.subscribe("cart:quantityUpdate:start", ({ key }) => {
    const cartItem = document.querySelector(`[data-key="${key}"]`);
    if (cartItem) {
      cartItem.classList.add("loading");
    }
  });

  PubSub.subscribe("cart:quantityUpdate:success", ({ key, data }) => {
    const cartItem = document.querySelector(`[data-key="${key}"]`);
    if (cartItem) {
      cartItem.classList.remove("loading");
      updateQuantityUI(cartItem, data.quantity);
    }

    updateGlobalCartUI({
      itemCount: data.itemCount,
      totals: data.totals,
    });
  });

  // Handle item removal
  PubSub.subscribe("cart:itemRemove:start", ({ key }) => {
    const cartItem = document.querySelector(`[data-key="${key}"]`);
    if (cartItem) {
      cartItem.classList.add("loading");
    }
  });

  PubSub.subscribe("cart:itemRemove:success", ({ key, data }) => {
    const cartItem = document.querySelector(`[data-key="${key}"]`);

    if (cartItem) {
      cartItem.remove();
      updateGlobalCartUI({
        itemCount: data.itemCount,
        totals: data.totals,
      });
    }

    if (data.itemCount === 0) {
      location.reload();
    }
  });

  // Handle add to cart
  PubSub.subscribe("cart:addItem:success", ({ data }) => {
    updateGlobalCartUI({
      itemCount: data.cart_count,
      totals: data.cart_total,
    });

    const cartOffcanvasContent = document.querySelector(
      ".cart-offcanvas-content"
    );

    if (cartOffcanvasContent) {
      // If cart was empty, rebuild entire cart structure
      if (cartOffcanvasContent.querySelector(".empty-cart-message")) {
        cartOffcanvasContent.innerHTML = `
          <div class="cart-offcanvas-items"></div>
          <div class="cart-offcanvas-footer">
            <div class="subtotal">
              <span>${cartVars.texts.subtotal}:</span>
              <span class="amount">${data.cart_total}</span>
            </div>
            <a href="${cartVars.checkoutUrl}" class="checkout-button">
              ${cartVars.texts.checkout}
            </a>
            <a href="${cartVars.cartUrl}" class="view-cart-button">
              ${cartVars.texts.viewCart}
            </a>
          </div>
        `;
      }

      // Now update the cart items
      const cartItems = cartOffcanvasContent.querySelector(
        ".cart-offcanvas-items"
      );
      if (cartItems && data.cart_items) {
        updateCartItemsUI(cartItems, data.cart_items);
      }
    }
  });

  // Handle errors
  PubSub.subscribe("cart:quantityUpdate:error", ({ key, error }) => {
    const cartItem = document.querySelector(`[data-key="${key}"]`);
    if (cartItem) {
      cartItem.classList.remove("loading");
      // Could add error UI feedback here
    }
  });

  PubSub.subscribe("cart:itemRemove:error", ({ key, error }) => {
    const cartItem = document.querySelector(`[data-key="${key}"]`);
    if (cartItem) {
      cartItem.classList.remove("loading");
      // Could add error UI feedback here
    }
  });

  PubSub.subscribe("cart:addItem:error", ({ error }) => {
    // Could add error UI feedback here
    console.error("Add to cart error:", error);
  });
}

function updateCartItemsUI(container, items) {
  if (!items.length) {
    const cartContent = container.closest(".cart-offcanvas-content");
    if (cartContent) {
      cartContent.innerHTML = `
        <div class="empty-cart-message">
          <p>${cartVars.texts.cartEmpty}</p>
          <a href="${cartVars.shopUrl}" class="button">${cartVars.texts.shopNow}</a>
        </div>
      `;
    }
    return;
  }

  container.innerHTML = items
    .map(
      (item) => `
    <div class="cart-offcanvas-item" data-key="${item.key}">
      <a href="${item.url}">
        <div class="item-image">
          <img src="${item.image}" alt="${item.name}">
        </div>
      </a>
        <div class="item-details">
          <h3>${item.name}</h3>
          <div class="item-price">${item.price}</div>
          <div class="item-quantity">
            <button class="quantity-btn minus" ${
              item.quantity <= 1 ? "disabled" : ""
            }>-</button>
            <input type="number" value="${item.quantity}" data-stock="${
        item.max_stock
      }" min="1" readonly>
            <button class="quantity-btn plus" ${
              item.quantity >= item.max_stock ? "disabled" : ""
            }>+</button>
          </div>
        </div>
      <button class="remove-item">×</button>
    </div>
  `
    )
    .join("");

  setupCartItemEventListeners();
}

// Add event delegation to prevent anchor navigation when clicking controls
function setupCartItemEventListeners() {
  const cartItems = document.querySelectorAll(".cart-offcanvas-item");

  cartItems.forEach((item) => {
    const quantityControls = item.querySelectorAll(".quantity-btn");
    const removeButton = item.querySelector(".remove-item");

    quantityControls.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleQuantityChange(e, item);
      });
    });

    if (removeButton) {
      removeButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        removeCartItem(item.dataset.key);
      });
    }
  });
}

function updateQuantityUI(cartItem, quantity) {
  const input = cartItem.querySelector("input");
  const minusBtn = cartItem.querySelector(".minus");
  const plusBtn = cartItem.querySelector(".plus");
  const maxStock = parseInt(input.getAttribute("data-stock"), 10) || 9999;

  input.value = quantity;
  minusBtn.disabled = quantity <= 1;
  plusBtn.disabled = quantity >= maxStock;
}

function updateGlobalCartUI(data) {
  if (!data) return;

  const { itemCount, totals, cart_subtotal } = data;

  // Update cart count
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = itemCount;
  });

  // Update subtotal - prefer cart_subtotal if available
  const subtotalToShow = cart_subtotal || totals;
  document.querySelectorAll(".cart-offcanvas-footer .amount").forEach((el) => {
    el.innerHTML = subtotalToShow;
  });

  // Update cart state visibility
  const cartContent = document.querySelector(".cart-offcanvas-content");
  if (cartContent && itemCount === 0) {
    cartContent.innerHTML = `
      <div class="empty-cart-message">
        <p>${cartVars.texts.cartEmpty}</p>
        <a href="${cartVars.shopUrl}" class="button">${cartVars.texts.shopNow}</a>
      </div>
    `;
  }
}
